import React, { useEffect, useState } from 'react';

import { Badge, withStyles } from '@material-ui/core';
import Alerts from '@material-ui/icons/Warning';
import { useSelector } from 'react-redux';
import { USER_ALERT_STATUS } from '../../util/constants';

const styles = (theme) => ({
  textContainer: {
    wordWrap: "break-word"
  }
});

const AlertIcon = (props) => {
  const { classes } = props;
  const [alertCount, setAlertCount] = useState(0);
  const alerts = useSelector((state) => state.alerts.alerts); 

  useEffect(() => {
    if (alerts) {
      setAlertCount(alerts.filter((alert) => alert.status === USER_ALERT_STATUS.NEW).length);
    }
  }, [alerts]);

  return (
    <Badge badgeContent={alertCount} color={alertCount ? "error" : "primary"} max={999} style={{ userSelect:  'none' }}>
      <Alerts />  
    </Badge>
  );
}

export default withStyles(styles)(AlertIcon);
